<template>
  <button
    :class="computedClass"
    :type="type"
    :disabled="disabled"
    @click="click"
  >
    <img class="busy-loading-icon" src="../assets/loader.svg" v-if="busy">
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "cancel",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "button",
    },
    busy: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
  computed: {
    computedClass() {
      return [
        "queue-button",
        `variant-${this.variant}`,
        this.disabled ? "btn-disabled" : "",
      ];
    },
  },
};
</script>

<style scoped>
.queue-button {
  padding: 1.6vh 1.5vh;
  border-radius: 5vh;
  font-size: 2vh;
  line-height: normal;
  border: 0;
  font-weight: 500;
  box-shadow: 0px 4px 1px rgba(0, 0, 0, 0.25);
  color: white;
  outline: none;
}

.w-60 {
  width: 60vw;
}

.circle {
  width: 6vh;
  height: 6vh;
}

.circle {
  width: 6vh;
  height: 6vh;
}

.circle {
  width: 6vh;
  height: 6vh;
}

.variant-cancel {
  background: #e2223b;
}

.variant-grey {
  background: #a4a3a1;
}

.variant-grey {
  background: #a4a3a1;
}

.variant-cancel-black {
  background: #1d1d1b;
}

.variant-light-outline {
  background: transparent;
  color: #1d1d1b;
  border: 1px solid #1d1d1b;
  box-shadow: none;
}

.variant-dark {
  color: #ededed;
  background-color: #1d1d1b;
}

.variant-card-cancel {
  background: #e2223b;
  padding: 1.6vh 4vw;
  width: 6vh;
  height: 6vh;
}

.variant-accept {
  background: #129b81;
}

.variant-confirm {
  background: #cbd9e6;
  color: #1d1d1b;
}

.variant-serve {
  background: #aeccc6;
  color: #1d1d1d;
}

.variant-cancel-outline {
  color: #e2223b;
  background: transparent;
  border: 1px solid #e2223b;
  box-shadow: none;
}

.variant-edit {
  background: white;
  border: 1px solid #1d1d1d;
  color: #1d1d1b;
}

.btn-disabled {
  color: #1d1d1b;
  background: #bcbcbc;
}

@media (min-width: 768px) {
  .queue-button {
    padding: 0.88vw 0;
    font-size: 1.1vw;
  }
  button.queue-button.variant-accept,
  button.queue-button.variant-serve,
  button.queue-button.action-confirmPay {
    width: 15.625vw;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;
  }
  button.queue-button.action-confirmPay.w-100.variant-dark,
  button.queue-button.variant-serve,
  .bg-preorder.w-100.queue-button.variant-cancel {
    width: 15.625vw;
    margin: 0;
    font-size: 1.111vw;
  }
  .w-100.queue-button.variant-accept,
  .w-100.queue-button.variant-serve,
  .w-100.queue-button.variant-cancel {
    width: 80% !important;
  }

  button.queue-button.variant-card-cancel,
  button.queue-button.variant-cancel {
    width: 3.472vw;
    height: 3.472vw;
    display: flex;
    padding: 0;
    align-items: center;
    justify-content: center;
    margin: 0;
  }
  button.queue-button.variant-edit,
  button.queue-button.variant-accept {
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  button.queue-button.variant-cancel img {
    width: 1.389vw;
    height: 1.389vw;
  }
  img.del {
    width: 1.389vw;
    height: 1.389vw;
  }
}
</style>
